import { AppConfigService } from 'app/utils/appconfig/app-config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MaintenanceType, MaintenanceItem } from 'next-typescript-api';

@Injectable()
export class MaintenanceService {
    closedByUser = false;
    private apiUrl: string;

    constructor(private http: HttpClient, private config: AppConfigService) {
        this.apiUrl = this.config.appConfig.apiHost;
    }

    getMaintenanceItems(type: MaintenanceType, withInUpcomingHours: number, maxItems: number): Observable<MaintenanceItem[]> {
        const url = `${this.apiUrl}/maintenances/${type}/${withInUpcomingHours}/${maxItems}?api-version=2.0`;
        return this.http.get<MaintenanceItem[]>(url);
    }
}
